/* eslint-disable no-restricted-syntax,no-prototype-builtins */
import api from '../../utils/apiFetch';

const path = 'gift-cards';
const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

export default {
  setGiftCardConfig: (payload) => api.post(`${path}`, payload),
  getGiftCardConfig: (giftCardId) => api.get(`${path}/${giftCardId}`),
  getGiftCardConfigList: (params) => api.get(`${path}?${serialize(params)}`),
  setGiftCardImage: (payload) => api.file(`${path}/creativeimage`, payload),
  getLanguages: () => api.get(`${path}/languages`),
  // GiftCardTerms
  getGiftCardTermsByGiftCardConfig: (giftCardConfigId) =>
    api.get(`${path}/${giftCardConfigId}/gift-card-terms`),
  setGiftCardTerms: (giftCardConfigId, payload) =>
    api.post(`${path}/${giftCardConfigId}/gift-card-terms`, payload),
  updateStatusGiftCardTerms: (occasionId, giftCardConfigId, payload) =>
    api.post(
      `${path}/${giftCardConfigId}/gift-card-terms/${occasionId}/update-status`,
      payload
    ),

  updateStatusGiftCardConfig: (id, payload) =>
    api.post(`${path}/${id}/update-status`, payload),

  setDefaultGiftCardConfig: (id) => api.post(`${path}/${id}/set-default`),
  // GiftCardImages
  getGiftCardImages: (giftCardConfigId) =>
    api.get(`${path}/${giftCardConfigId}/gift-card-images`),
  setGiftCardImagesByGiftCardConfig: (giftCardConfigId, payload) =>
    api.post(`${path}/${giftCardConfigId}/gift-card-images`, payload),
  updateStatusGiftCardImages: (occasionId, giftCardConfigId, payload) =>
    api.post(
      `${path}/${giftCardConfigId}/gift-card-images/${occasionId}/update-status`,
      payload
    ),
  // Occasions
  getOccasionsByGiftCardConfig: (giftCardConfigId) =>
    api.get(`${path}/${giftCardConfigId}/occasions`),
  updateStatusOccasions: (occasionId, giftCardConfigId, payload) =>
    api.post(
      `${path}/${giftCardConfigId}/occasions/${occasionId}/update-status`,
      payload
    ),
  setOccasions: (giftCardConfigId, payload) =>
    api.post(`${path}/${giftCardConfigId}/occasions`, payload),
  setGiftCardImages: (id) => api.get(`${path}/images/${id}`),
  issuePhysicalGiftCard: (payload) =>
    api.post(`${path}/physical/issue`, payload),
  getPhysicalGiftCardBalance: (code) => api.get(`${path}/balance/${code}`),
  updateGiftCardTermDescription: (occasionId, payload) =>
    api.post(`${path}/gift-card-terms/${occasionId}/update`, payload),
  getGiftCardRedeemTransactions: (params) =>
    api.get(`${path}/redemptions?${serialize(params)}`),
  deleteGiftCardImage: (giftCardConfigId, imageId) =>
    api.deleteRequest(`${path}/${giftCardConfigId}/image/${imageId}`),
  updateGiftCardImages: (giftCardConfigId, payload) =>
    api.put(`${path}/${giftCardConfigId}/image`, payload),
  updateGiftCardImageOrder: (giftCardConfigId, payload) =>
    api.put(`${path}/${giftCardConfigId}/gift-card-images/order`, payload),
  updateOccasions: (giftCardConfigId, payload) =>
    api.put(`${path}/${giftCardConfigId}/occasion`, payload),
  deleteOccasions: (id) => api.deleteRequest(`${path}/occasion/${id}`),
  deleteCardTerm: (id) => api.deleteRequest(`${path}/gift-card-term/${id}`),
  updateGiftCardUserInfo: (payload) => api.put(`${path}/user-info`, payload),
  getGCRedemptionsApi: (params) =>
    api.get(`${path}/redemptions?${serialize(params)}`),
  getGCRedemptionsByBusinessApi: (params) =>
    api.get(`${path}/redemptions-by-business?${serialize(params)}`),
  getGCRedemptionsByLocationApi: (params) =>
    api.get(`${path}/redemptions-by-location?${serialize(params)}`),
  getTopPurchasedCustomers: (params) =>
    api.get(`${path}/top-purchased-customers?${serialize(params)}`),
  getTopPurchasedCustomersStats: (params) =>
    api.get(`${path}/top-purchased-customers-stats?${serialize(params)}`),
  getTopPurchasedEnterprisesStats: (params) =>
    api.get(`${path}/top-purchased-enterprises-stats?${serialize(params)}`),
  updateOrderGcApi: (payload) =>
    api.put(`${path}/giftcard-config-order`, payload),
  updateIsPhysicalCard: (payload) =>
    api.put(`${path}/is-physical-card-image`, payload),
  setColorConfigApi: (payload) => api.post(`${path}/color-config`, payload),
  getColorConfigApi: () => api.get(`${path}/color-config`),
  setMiscConfigApi: (payload) => api.post(`${path}/misc`, payload),
  getMiscConfigApi: () => api.get(`${path}/misc`),
  getSettlement: (params) => api.get(`${path}/settlement?${serialize(params)}`),
  getGiftCardsWithBalance: (params) =>
    api.get(`${path}/with-balance?${serialize(params)}`),
  getGiftCardTransactionHistory: (code, params) =>
    api.get(`${path}/${code}/transaction-history?${serialize(params)}`),
};
